import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import InApplication from '@/pages/InApplication'
import domConversionOfd from '@/pages/domConversionOfd'
import imgConversion from '@/pages/imgConversion'
import servicePages from '@/pages/servicePages'
import aboutUs from '@/pages/aboutUs'
import readPage from '@/pages/readPage'
import shareReadPage from '@/pages/shareReadPage'
import readering from '@/pages/reading'
import electronicCertificate from '@/pages/electronicCertificate'
import feedback from '@/pages/feedback'
import feedbackData from '@/pages/feedbackData'
import announcement from '@/pages/announcement'
import attestationPage from '@/pages/attestationPage'

Vue.use(Router)

const router = new Router({
    // mode: 'hash',
    mode: 'history',
    // base: '/supriloc-document-conversion/',
    routes: [{
            path: '/',
            component: index,
        },
        {
            path: '/InApplication/',
            name: 'InApplication',
            component: InApplication,
        },
        {
            path: '/domConversionOfd/',
            name: 'domConversionOfd',
            component: domConversionOfd,
        },
        {
            path: '/imgConversion/',
            name: 'imgConversion',
            component: imgConversion
        },
        {
            path: '/service',
            name: 'servicePages',
            component: servicePages,
            meta: {
                title: '联系我们'
            }
        },
        {
            path: '/aboutUs',
            name: 'aboutUs',
            component: aboutUs,
            meta: {
                title: '关于我们'
            }
        },
        {
            path: '/onlinePreview/',
            name: 'onlinePreview',
            component: () => import('@/pages/onlinePreview.vue')
        },
        {
            path: '/readering',
            name: 'readering',
            component: readering,
            meta: {
                title: '轻阅读'
            }
        },
        {
            path: '/readering:id',
            name: 'readering',
            component: readering,
            meta: {
                title: '轻阅读'
            }
        },
        {
            path: '/r',
            name: 'readPage',
            component: readPage,
            meta: {
                title: '轻阅读'
            }
        },
        {
            path: '/r:url',
            name: 'readPage',
            component: readPage,
            meta: {
                title: '轻阅读'
            }
        },
        {
            path: '/s:url',
            name: 'shareReadPage',
            component: shareReadPage,
            meta: {
                title: '轻阅读'
            }
        },
        {
            path: '/electronicCertificate',
            name: 'electronicCertificate',
            component: electronicCertificate,
            meta: {
                title: '电子凭证'
            }
        },
        {
            path: '/feedback',
            name: 'feedback',
            component: feedback,
            meta: {
                title: '问题反馈'
            }
        },
        {
            path: '/feedbackData',
            name: 'feedbackData',
            component: feedbackData,
            meta: {
                title: '查看用户反馈数据'
            }
        },
        {
            path: "/announcement",
            name: "announcement",
            component: announcement,
        },
        {
            path: "/details/:id",
            name: "announDetails",
            component: () => import("@/pages/announcement/details.vue")
        },
        {
            path: "/attestationPage",
            name: "attestationPage",
            component: attestationPage,
        },
    ]
})

//重置滚动条位置
router.afterEach((to, from) => {
    if (document.querySelector('#top')) {
        document.querySelector('#top').scrollIntoView(true);
    }
})

export default router



// WEBPACK FOOTER //
// ./src/supubwps-document-conversion/router/index.js